<template>
  <Layout title="Transport Voucher" description="Review and manage transport vouchers">
    <div class="container py-4" style="max-width: 1100px;">
      <div class="card shadow">
        <div class="card-header bg-dark text-light">
          <h4 class="mb-0">Transport Voucher</h4>
        </div>

        <div class="card-body">

          <!-- Canvas Preview -->
          <div class="text-center mb-4">
            <canvas
              ref="voucherCanvas"
              class="border rounded bg-white"
              style="width:100%;max-width:900px;"
            />
          </div>

          <!-- ===== BASIC FIELDS ===== -->
          <div class="row g-2 small mb-3">
            <div class="col-md-4"><label>Vessel</label><input v-model="form.vessel" class="form-control form-control-sm"/></div>
            <div class="col-md-4"><label>PIC</label><input v-model="form.pic" class="form-control form-control-sm"/></div>
            <div class="col-md-4"><label>Driver</label><input v-model="form.driver" class="form-control form-control-sm"/></div>

            <div class="col-md-3"><label>Date</label><input v-model="form.date" type="date" class="form-control form-control-sm"/></div>
            <div class="col-md-3">
              <label>Start Time</label>
              <input
                v-model="form.timeStart"
                type="text"
                placeholder="HH:mm"
                class="form-control form-control-sm"
              />
            </div>

            <div class="col-md-3">
              <label>End Time</label>
              <input
                v-model="form.timeEnd"
                type="text"
                placeholder="HH:mm"
                class="form-control form-control-sm"
              />
            </div>
            <div class="col-md-3"><label>Vehicle No</label><input v-model="form.vehicleNo" class="form-control form-control-sm"/></div>

            <div class="col-md-6"><label>From</label><input v-model="form.from" class="form-control form-control-sm"/></div>
            <div class="col-md-6"><label>To</label><input v-model="form.to" class="form-control form-control-sm"/></div>

            <div class="col-md-4"><label>Rank</label><input v-model="form.rank" class="form-control form-control-sm"/></div>
            <div class="col-md-4"><label>Crew</label><input v-model="form.crew" class="form-control form-control-sm"/></div>
            <div class="col-md-4"><label>Pax</label><input v-model="form.pax" class="form-control form-control-sm"/></div>

            <div class="col-md-12"><label>Flight</label><input v-model="form.flight" class="form-control form-control-sm"/></div>
          </div>

          <!-- ===== SWITCHES ===== -->
          <div class="row g-2 mb-3">
            <div v-for="(v,k) in serviceFlags" :key="k" class="col-md-4">

              <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="form[k]" />
                <label class="form-check-label">{{ v.label }}</label>
              </div>

              <!-- <input
                v-if="form[k]"
                v-model.number="v.amount"
                type="number"
                placeholder="Amount"
                class="form-control form-control-sm mt-1"
              /> -->

            </div>
          </div>

          <!-- Conditional Info -->
          <div class="mt-2" v-if="form.waitingHrs">
            <label>Waiting Hrs Info</label>
            <input v-model="form.waitingHrsInfo"
                  class="form-control form-control-sm"/>
          </div>
          <div class="mb-3" v-if="form.additionalStop">
            <label>Additional Stop Info</label>
            <input v-model="form.additionalStopInfo" class="form-control form-control-sm"/>
          </div>

          <div class="mb-3" v-if="form.disposal">
            <label>Disposal Info</label>
            <input v-model="form.disposalInfo" class="form-control form-control-sm"/>
          </div>

          <div class="mb-3">
            <label>Remarks</label>
            <textarea v-model="form.remarks" class="form-control form-control-sm"/>
          </div>

          <!-- ===== SIGNATURE ===== -->
          <h6 class="fw-bold mt-3">Signature</h6>
          <canvas
            ref="signaturePad"
            width="600"
            height="160"
            class="border rounded"
            style="touch-action:none"
            @mousedown="startSign"
            @mousemove="drawSign"
            @mouseup="endSign"
            @mouseleave="endSign"
            @touchstart.prevent="startSign"
            @touchmove.prevent="drawSign"
            @touchend.prevent="endSign"
          />

          <button class="btn btn-sm btn-outline-secondary mt-2" @click="clearSign">
            Clear Signature
          </button>

          <div class="text-center mt-4">
            <button class="btn btn-primary px-4" @click="saveVoucher">
              Save Voucher
            </button>
          </div>

        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/Layout.vue'
import axios from 'axios'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import { useToast } from 'vue-toastification'
import router from '@/router'


export default {
  name: 'VoucherPage',
  components: { Layout },

  data() {
    return {
      bookingID: '',
      voucherId: '',
      voucherBg: require('@/assets/transportVoucher.png'),
      isUploading: false,

      signing: false,
      signCtx: null,

      // serviceFlags: {
      //   crewTransportation: 'Crew Transportation',
      //   deliveryCollection: 'Delivery / Collection',
      //   erp: 'ERP',
      //   waitingHrs: 'Waiting Hrs',
      //   meals: 'Meals for Crew',
      //   additionalStop: 'Additional Stop',
      //   parking: 'Parking Fee',
      //   oddSurcharge: 'Odd Hrs Surcharge',
      //   meeting: 'Meeting Services',
      //   disposal: 'Disposal'
      // },
      serviceFlags: {
        crewTransportation: { label:'Crew Transportation', amount:0 },
        deliveryCollection: { label:'Delivery / Collection', amount:0 },
        erp: { label:'ERP', amount:0 },
        waitingHrs: { label:'Waiting Hrs', amount:0 },
        meals: { label:'Meals for Crew', amount:0 },
        additionalStop: { label:'Additional Stop', amount:0 },
        parking: { label:'Parking Fee', amount:0 },
        oddSurcharge: { label:'Odd Hrs Surcharge', amount:0 },
        meeting: { label:'Meeting Services', amount:0 },
        disposal: { label:'Disposal', amount:0 },
        arrival:{label:'Arrival', amount:0},
        departure:{label:'Departure', amount:0}
      },
      serviceRemarks: '',
      form: {
        voucherId:"",
        vessel: '',
        pic: '',
        driver: '',
        vehicleNo: '',

        date: '',
        timeStart: '',
        timeEnd: '',

        from: '',
        to: '',
        rank: '',
        crew: '',
        pax: '',
        flight: '',
        remarks: '',

        crewTransportation: false,
        deliveryCollection: false,
        erp: false,
        waitingHrs: false,
        meals: false,
        additionalStop: false,
        parking: false,
        oddSurcharge: false,
        meeting: false,
        disposal: false,
        waitingHrsInfo: '',
        additionalStopInfo: '',
        disposalInfo: '',
        arrival: false, 
        departure:false
      },

      drivers: [],
      driverMap: {},
      clients: [],
      clientMap: {},
      booking: null
    }
  },

  setup() {
    return { toast: useToast() }
  },

  async mounted() {
    await this.checkAuthState()
    await this.checkPageAccess(["admin"])

    this.bookingID = this.$route.params.id
    // this.voucherId = `${this.bookingID}-${Math.random()
    //   .toString(36)
    //   .substring(2, 6)
    //   .toUpperCase()}`

    await this.fetchDriversSimple()
    await this.fetchClientsSimple()
    await this.fetchBookingById(this.bookingID)
    // this.form.voucherId = "VCHR-" + crypto.randomUUID().replace(/-/g, "").slice(0, 8).toUpperCase()
    this.drawVoucher()

    Object.keys(this.form).forEach(k => {
      this.$watch(`form.${k}`, this.drawVoucher)
    })
  },
  // watch:{
  //     serviceFlags:{
  //       handler(){
  //         this.updateServiceRemarks()
  //         this.drawVoucher()
  //       },
  //       deep:true
  //     },
  //     // form:{
  //     //   handler(){
  //     //     this.updateServiceRemarks()
  //     //   },
  //     //   deep:true
  //     // }
  //   } ,

  methods: {
    checkPageAccess(allowedRoles = []) {
      const access = this.$store.state.systemAccess || {}

      const hasAccess = allowedRoles.some(role => access[role] === true)

      if (!hasAccess) {
        this.toast.error("Access denied.")

        if (access.admin === true) {
          router.push("/crm")
        } else if (access.client === true) {
          router.push("/JobManagementClient")
        } else if (access.driver === true) {
          router.push("/JobManagementDriver")
        } else {
          router.push("/")
        }
      }
    },
    // ================= AUTH =================
    async getAuthHeader() {
      const user = getAuth().currentUser
      if (!user) throw new Error('Not logged in')
      return { Authorization: await user.getIdToken() }
    },

    async checkAuthState() {
      const auth = getAuth()
      return new Promise((resolve, reject) => {
        onAuthStateChanged(auth, async user => {
          if (user) resolve()
          else {
            router.push('/')
            reject()
          }
        })
      })
    },

    // ================= DATA =================
    async fetchDriversSimple() {
      const headers = await this.getAuthHeader()
      const res = await axios.get(`${this.$apiURL}/api/drivers/simple`, { headers })
      this.drivers = res.data?.drivers || []

      this.driverMap = {}
      this.drivers.forEach(d => {
        this.driverMap[d.id] = {
          name: d.name,
          vehicleNo: d.vehicleNo
        }
      })
    },

    async fetchClientsSimple() {
      const headers = await this.getAuthHeader()
      const res = await axios.get(`${this.$apiURL}/api/clients/simple`, { headers })
      this.clients = res.data?.clients || []

      this.clientMap = {}
      this.clients.forEach(c => (this.clientMap[c.id] = c.name))
    },

    async fetchBookingById(id) {
      const headers = await this.getAuthHeader()
      const res = await axios.get(
        `${this.$apiURL}/api/bookings/single/${id}`,
        { headers }
      )

      this.booking = res.data.booking
      this.mapBookingToVoucher(this.booking)
    },

    mapBookingToVoucher(b) {
      // V1 fallback
      if (b.crewName && b.crewName.trim() !== '') {
        this.form.crew = b.crewName
      }
      // V2
      else if (Array.isArray(b.crewMembers) && b.crewMembers.length > 0) {
        console.log("HERE", b.crewMembers[0]?.rank || '' )
        this.form.crew = b.crewMembers[0]?.name || ''
        this.form.rank = b.crewMembers[0]?.rank || '' 

      }
      else {
        this.form.crew = ''
      }
      this.form.vessel = b.vesselName || ''
      this.form.from = b.startLocation || ''
      this.form.to = b.endLocation || ''
      // this.form.crew = b.crewName || ''
      // this.form.rank = b.rank || ''
      this.form.pax = b.pax || ''
      this.form.remarks = b.remarks || ''

      this.form.pic = this.clientMap[b.clientId] || ''

      if (Array.isArray(b.driverIDs)) {
        this.form.driver = b.driverIDs
          .map(id => this.driverMap[id]?.name)
          .filter(Boolean)
          .join(' / ')

        this.form.vehicleNo = b.driverIDs
          .map(id => this.driverMap[id]?.vehicleNo)
          .filter(Boolean)
          .join(' / ')
      }

      // Flights
      try {
        const flights =
          typeof b.flightNumbers === 'string'
            ? JSON.parse(b.flightNumbers)
            : b.flightNumbers
        this.form.flight = Array.isArray(flights)
          ? flights.map(f => f.number).join(', ')
          : ''
      } catch {console.log("error")}

      // Date
      if (b.startTime) {
        const d = new Date(b.startTime)

        const day = String(d.getDate()).padStart(2, '0')
        const month = String(d.getMonth() + 1).padStart(2, '0')
        const year = d.getFullYear()

        this.form.date = `${day}/${month}/${year}`
      }

      // ⏱ On Board / Completed times
      // In mapBookingToVoucher(b)
      if (b.status_timeline?.on_board?.at) {
        const d = new Date(b.status_timeline.on_board.at)
        this.form.timeStart = d.toTimeString().slice(0, 5)
      }

      if (b.status_timeline?.completed?.at) {
        const d = new Date(b.status_timeline.completed.at)
        this.form.timeEnd = d.toTimeString().slice(0, 5)
      }
   
      
    },

    // ================= CANVAS =================
    drawVoucher() {
      const canvas = this.$refs.voucherCanvas
      const ctx = canvas.getContext('2d')
      const img = new Image()
      img.crossOrigin = 'anonymous'
      img.src = this.voucherBg

      img.onload = () => {
        canvas.width = img.width
        canvas.height = img.height
        ctx.drawImage(img, 0, 0)

        ctx.fillStyle = '#000'
        ctx.font = '26px Arial'

        // ctx.font = '35px Arial' 
        ctx.fillStyle = 'red' 
        ctx.fillText(this.form.voucherId, 1570, 75) 
        ctx.fillStyle = 'black' 
        ctx.fillText(this.form.pax, 650, 300) 
        ctx.fillText(this.form.vessel, 430, 450) 
        ctx.fillText(this.form.date, 1450, 140) 
        ctx.fillText(this.form.flight, 1640, 240) 
        ctx.fillText(this.form.rank, 1300, 380) 
        ctx.fillText(this.form.crew, 430, 380) 
        ctx.fillText(this.form.from, 430, 520) 
        ctx.fillText(this.form.to, 1300, 520) 
        ctx.fillText(this.form.vehicleNo, 400, 1020) 
        ctx.fillText(this.form.pic, 1300, 450) 
        ctx.fillText(this.form.driver, 720, 1020) 
        // ctx.fillText(this.form.time, 560, 230) 
        // ctx.fillText(this.form.crew, 270, 350) 
        ctx.font = '20px Arial'

        const remarks = this.form.remarks || ""
        const maxWidth = ctx.measureText("WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW").width
        const lineHeight = 83

        let y = 1120
        let line = ""
        let lineCount = 0

        for (let i = 0; i < remarks.length; i++) {

          // if already on line 3 → no more wrapping
          if (lineCount === 2) {
            line += remarks.slice(i)
            break
          }

          const testLine = line + remarks[i]
          const width = ctx.measureText(testLine).width

          if (width > maxWidth && line !== "") {

            ctx.fillText(line, 360, y)

            line = remarks[i]
            y += lineHeight
            lineCount++

          } else {
            line = testLine
          }

        }

        ctx.fillText(line, 360, y)
        ctx.font = '26px Arial'
        ctx.fillText(this.form.timeStart, 430, 590)
        ctx.fillText(this.form.timeEnd, 1300, 590)
        // Services ✔
        // ===== Services (hard-coded positions) =====
        ctx.fillStyle = '#000'
        ctx.font = '45px Arial'

        // Crew Transportation
        if (this.form.crewTransportation) {
          ctx.fillText('✔', 385, 300)
        }

        if (this.form.departure) {

          const x = 1460
          const y = 240
          const radius = 35
          ctx.lineWidth = 6   // thicker border

          ctx.beginPath()
          ctx.arc(x, y, radius, 0, Math.PI * 2)
          ctx.stroke()

        }
        if (this.form.arrival) {

          const x = 1390
          const y = 240
          const radius = 35
          ctx.lineWidth = 6   // thicker border
          ctx.beginPath()
          ctx.arc(x, y, radius, 0, Math.PI * 2)
          ctx.stroke()
          
        }

        // Delivery / Collection
        if (this.form.deliveryCollection) {
          ctx.fillText('✔', 900, 300)
        }
        // ERP
        if (this.form.erp) {
          ctx.fillText('✔', 210, 765)
        }

        // Waiting Hours
        if (this.form.waitingHrs) {
          ctx.fillText('✔', 470, 760)
          if (this.form.waitingHrsInfo) {
            ctx.font = '26px Arial'
            const text = this.form.waitingHrsInfo

            if (text.length <= 15) {
              ctx.fillText(text, 675, 760)
            } else {
              const line1 = text.slice(0, 15)
              const line2 = text.slice(15)

              ctx.fillText(line1, 675, 760)
              ctx.fillText(line2, 675, 785) // move down a bit
            }
            ctx.font = '45px Arial'

          }
        }

        // Meals for Crew
        if (this.form.meals) {
          ctx.fillText('✔', 875, 760)
        }

        // Additional Stop
        if (this.form.additionalStop) {
          ctx.fillText('✔', 1165, 760)
          if (this.form.additionalStopInfo) {
            ctx.font = '26px Arial'
            ctx.fillText(this.form.additionalStopInfo, 1400, 755)
            ctx.font = '45px Arial'
          }
        }

        // Parking Fee
        if (this.form.parking) {
          ctx.fillText('✔', 210, 870)
        }

        // Odd Hours Surcharge
        if (this.form.oddSurcharge) {
          ctx.fillText('✔', 470, 870)
        }

        // Meeting Services
        if (this.form.meeting) {
          ctx.fillText('✔', 875, 865)
        }

        // Disposal
        if (this.form.disposal) {
          ctx.fillText('✔', 1167, 865)
          if (this.form.disposalInfo) {
            ctx.font = '26px Arial'
            ctx.fillText(this.form.disposalInfo, 1365, 855)
          }
        }

        ctx.font = '26px Arial'

        // if (this.form.additionalStopInfo)
        //   ctx.fillText(this.form.additionalStopInfo, 180, 720)

        // if (this.form.disposalInfo)
        //   ctx.fillText(this.form.disposalInfo, 180,720)

        // Signature
        const sig = this.$refs.signaturePad
        ctx.drawImage(sig, 1300, 1000, 250, 250)

      }
    },

    // ================= SIGNATURE =================
    startSign(e) {
      const c = this.$refs.signaturePad
      this.signCtx = c.getContext('2d')
      this.signCtx.lineWidth = 2
      this.signCtx.strokeStyle = '#000'

      const r = c.getBoundingClientRect()
      const p = e.touches ? e.touches[0] : e
      this.signCtx.beginPath()
      this.signCtx.moveTo(p.clientX - r.left, p.clientY - r.top)
      this.signing = true
    },

    drawSign(e) {
      if (!this.signing) return
      const c = this.$refs.signaturePad
      const r = c.getBoundingClientRect()
      const p = e.touches ? e.touches[0] : e
      this.signCtx.lineTo(p.clientX - r.left, p.clientY - r.top)
      this.signCtx.stroke()
      this.drawVoucher()
    },

    endSign() {
      this.signing = false
    },

    clearSign() {
      const c = this.$refs.signaturePad
      c.getContext('2d').clearRect(0, 0, c.width, c.height)
      this.drawVoucher()
    },
    updateServiceRemarks(){

      const lines = []

      Object.keys(this.serviceFlags).forEach(k=>{
        if(this.form[k]){
          const amount = this.serviceFlags[k].amount

          if(amount && amount > 0){
            lines.push(`${this.serviceFlags[k].label}SGD$${amount}`)
          }
        }
      })

      this.serviceRemarks  = lines.join(' ')

    },

    // ================= SAVE =================
    async saveVoucher() {
        this.drawVoucher()
        if (this.isUploading) return

        this.isUploading = true
        try {
          const headers = await this.getAuthHeader()
          const formData = new FormData()
          // ================================
          // 1️⃣ GENERATE SEQUENTIAL NUMBER
          // ================================
          const res2 = await axios.post(
            `${this.$apiURL}/api/voucher/generate-number`,
            {},
            { headers }
          );

          if (!res2.data?.success) {
            throw new Error("Failed to generate voucher number");
          }

          const voucherNumber = res2.data.voucherNumber;

          // set voucher id
          this.form.voucherId = voucherNumber;

          // ================================
          // 2️⃣ REDRAW VOUCHER WITH NUMBER
          // ================================
          await new Promise(resolve => {
            this.drawVoucher();
            setTimeout(resolve, 200);
          });
          // ================= BUILD PAYLOAD =================
          const payload = {
            voucherId : this.form.voucherId,
            vesselName: this.form.vessel,
            engagedBy: this.form.pic,
            driverName: this.form.driver,
            vehicleNo: this.form.vehicleNo,

            date: this.form.date,
            timeStart: this.form.timeStart || this.form.time,
            timeEnd: this.form.timeEnd || '',

            from: this.form.from,
            to: this.form.to,
            paxName: this.form.crew,
            rank:this.form.rank, 
            paxs: this.form.pax,
            flightNo: this.form.flight,
            remarks: this.form.remarks,

            // services
            crewTransportation: this.form.crewTransportation,
            delivery: this.form.deliveryCollection,
            erp: this.form.erp,
            waitingHrs: this.form.waitingHrs,
            waitingHrsInfo: this.form.waitingHrsInfo || '',
            mealsForCrew: this.form.meals,
            additionalStop: this.form.additionalStop,
            additionalStopInfo: this.form.additionalStopInfo || '',
            arrival: this.form.arrival || '',
            departure: this.form.departure || '',

            parkingFees: this.form.parking,
            oddHrsSurcharge: this.form.oddSurcharge,
            meetingServices: this.form.meeting,

            disposal: this.form.disposal,
            disposalInfo: this.form.disposalInfo || ''
          }

          // 🔹 backend expects JSON string under "data"
          formData.append("data", JSON.stringify(payload))

          // ================= VOUCHER IMAGE =================
          const voucherCanvas = this.$refs.voucherCanvas

          if (!voucherCanvas || !voucherCanvas.width || !voucherCanvas.height) {
            throw new Error("Voucher canvas not ready")
          }

          const voucherBlob = await new Promise((resolve, reject) => {
            voucherCanvas.toBlob(blob => {
              if (!blob) reject(new Error("Voucher blob is null"))
              else resolve(blob)
            }, "image/png")
          })

          formData.append(
            "file",
            voucherBlob,
            `TransportVoucher_${this.voucherId}.png`
          )

          // ================= SIGNATURE (OPTIONAL) =================
          const sigCanvas = this.$refs.signaturePad
          if (sigCanvas && sigCanvas.width && sigCanvas.height) {
            const sigBlob = await new Promise(resolve =>
              sigCanvas.toBlob(resolve, "image/png")
            )
            if (sigBlob) {
              formData.append(
                "signature",
                sigBlob,
                `Signature_${this.voucherId}.png`
              )
            }
          }

          // ================= API CALL =================
          const res = await axios.post(
            `${this.$apiURL}/api/bookings/${this.bookingID}/vouchers`,
            formData,
            { headers }
          )

          if (res.data?.ok) {
            this.toast.success("Voucher saved successfully")
            setTimeout(() => router.push("/JobManagement"), 600)
          } else {
            this.toast.error(res.data?.error || "Failed to save voucher")
          }

        } catch (err) {
          console.error("❌ saveVoucher error:", err)
          this.toast.error(err.message || "Error saving voucher")
        } finally {
          this.isUploading = false
        }
      }



  }
}
</script>
